var _style, _g, _path, _path2, _path3, _path4, _g2, _g3, _g4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 376.3",
    style: {
      enableBackground: "new 0 0 500 376.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222325;}\r\n\t.st1{fill:#393A3D;}\r\n\t.st2{opacity:0.64;fill:url(#SVGID_1_);}\r\n\t.st3{fill:#00C39A;}\r\n\t.st4{fill:#6C8095;}\r\n\t.st5{fill:url(#SVGID_00000108282454084598462160000000735681638367114377_);}\r\n\t.st6{fill:#FFFFFF;}\r\n\t.st7{fill:url(#SVGID_00000146477573793886158620000005446376759289838005_);}\r\n\t.st8{fill:url(#SVGID_00000001665470624905058450000003573290657323738804_);}\r\n\t.st9{fill:url(#SVGID_00000000203803788086861280000002751373841732596122_);}\r\n\t.st10{fill:url(#SVGID_00000125599962990510743720000016907945267507347119_);}\r\n\t.st11{fill:url(#SVGID_00000101081396931684912200000014644459818892478143_);}\r\n\t.st12{fill:url(#SVGID_00000170977939433214422340000009888755480712591015_);}\r\n\t.st13{fill:url(#SVGID_00000173861791520673950580000006968013840767165830_);}\r\n\t.st14{fill:url(#SVGID_00000108290443850951759460000006446192848013250739_);}\r\n\t.st15{fill:#393A3D;stroke:#6C8095;stroke-miterlimit:10;}\r\n\t.st16{fill:url(#SVGID_00000073696105237211060190000015875651247080651698_);}\r\n\t.st17{fill:url(#SVGID_00000001655566251301523090000000037162659629961121_);}\r\n\t.st18{fill:url(#SVGID_00000152262595093296656280000013808442837565558449_);}\r\n\t.st19{fill:url(#SVGID_00000173130982931739220140000000070253840053161872_);}\r\n\t.st20{opacity:0.45;fill:url(#SVGID_00000018955876411708737670000011562813066722524347_);}\r\n\t.st21{fill:url(#SVGID_00000009584321009149730800000007758636395356145035_);}\r\n\t.st22{fill:url(#SVGID_00000168116829460807943920000009816649478104296374_);}\r\n\t.st23{fill:url(#SVGID_00000137119967511289761280000004040336022945939368_);}\r\n\t.st24{fill:url(#SVGID_00000019664144838321270320000003944874859205197199_);}\r\n\t.st25{fill:url(#SVGID_00000039815133538882666970000005047593641335156615_);}\r\n\t.st26{opacity:0.25;fill:none;stroke:#FFFFFF;strokeWidth:0.4712;stroke-miterlimit:10;}\r\n\t.st27{fill:url(#SVGID_00000157277046724182011930000011111535266268224662_);}\r\n\t.st28{fill:url(#SVGID_00000046299808265932744830000005285211335294390181_);}\r\n\t.st29{fill:url(#SVGID_00000008845288239509481910000013477734491557691044_);}\r\n\t.st30{fill:url(#SVGID_00000027578017893854093140000013288908914431760008_);}\r\n\t.st31{opacity:0.57;fill:none;stroke:#FFFFFF;strokeWidth:0.4712;stroke-miterlimit:10;}\r\n\t.st32{fill:url(#SVGID_00000083791175041463330750000004405965095484518297_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.7,229.4L302.3,335.2c-50.2,44.1-126.7,39.2-170.8-11l0,0c-44.1-50.2-39.2-126.7,11-170.8L262.9,47.5 c50.2-44.1,126.7-39.2,170.8,11l0,0C477.9,108.8,473,185.3,422.7,229.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 227.3,
    cy: 240,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,240c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C241.8,237.9,242.7,238.9,242.7,240z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 253.9,
    cy: 240,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.3,240c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C268.4,237.9,269.3,238.9,269.3,240z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 280.5,
    cy: 240,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.4,250c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C228.5,247.9,229.4,248.9,229.4,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,250c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C241.8,247.9,242.7,248.9,242.7,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,250c0,1.2-0.9,2.1-2.1,2.1s-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1S256,248.9,256,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.3,250c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C268.4,247.9,269.3,248.9,269.3,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.6,250c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C281.7,247.9,282.6,248.9,282.6,250z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 227.3,
    cy: 260,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,260c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C241.8,257.9,242.7,258.8,242.7,260z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 253.9,
    cy: 260,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.3,260c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C268.4,257.9,269.3,258.8,269.3,260z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 280.5,
    cy: 260,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 227.3,
    cy: 270,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,270c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C241.8,267.9,242.7,268.8,242.7,270z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 253.9,
    cy: 270,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.3,270c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C268.4,267.9,269.3,268.8,269.3,270z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 280.5,
    cy: 270,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.4,280c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C228.5,277.9,229.4,278.8,229.4,280z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,280c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C241.8,277.9,242.7,278.8,242.7,280z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,280c0,1.2-0.9,2.1-2.1,2.1s-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1S256,278.8,256,280z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.3,280c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C268.4,277.9,269.3,278.8,269.3,280z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.6,280c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C281.7,277.9,282.6,278.8,282.6,280z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 227.3,
    cy: 290,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.7,290c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1 C241.8,287.9,242.7,288.8,242.7,290z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 253.9,
    cy: 290,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.3,290c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1 C268.4,287.9,269.3,288.8,269.3,290z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 280.5,
    cy: 290,
    r: 2.1
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 608.3561,
    y1: 617.3706,
    x2: 72.8069,
    y2: -32.2172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C39A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#393A3D"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M344.2,40l2.6,171.8c0,3-2.3,5.4-5.3,5.4L71,221.3c-2.9,0-5.4-2.3-5.4-5.3L63,44.2c0-2.9,2.3-5.4,5.3-5.4 l270.5-4.1C341.7,34.7,344.1,37,344.2,40z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M344.2,40l0.1,8.3L63.1,52.4L63,44.2c0-2.9,2.3-5.4,5.3-5.4l270.5-4.1C341.7,34.7,344.1,37,344.2,40z"
  })), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M334,41.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6 C333.2,40,333.9,40.7,334,41.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041253823602769892800000010954598866044246463_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.9674,
    y1: 31.9093,
    x2: 322.9269,
    y2: 53.9532
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.1e-7,
    style: {
      stopColor: "#51D6B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#98E2B9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041253823602769892800000010954598866044246463_)"
    },
    d: "M323.4,41.7c0,0.9-0.7,1.6-1.6,1.6 c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6C322.7,40.1,323.4,40.8,323.4,41.7z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M312.9,41.9c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6 C312.2,40.3,312.9,41,312.9,41.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.7,156.2c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4S141.7,155.5,141.7,156.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M150.6,156.2c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C150,154.8,150.6,155.5,150.6,156.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M159.6,156.2c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C159,154.8,159.6,155.5,159.6,156.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M168.6,156.2c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C167.9,154.8,168.6,155.5,168.6,156.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.6,156.2c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C176.9,154.8,177.6,155.5,177.6,156.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.7,163c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4S141.7,162.2,141.7,163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M150.6,163c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C150,161.6,150.6,162.2,150.6,163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M159.6,163c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C159,161.6,159.6,162.2,159.6,163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M168.6,163c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C167.9,161.6,168.6,162.2,168.6,163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.6,163c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C176.9,161.6,177.6,162.2,177.6,163z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.7,169.7c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4S141.7,168.9,141.7,169.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M150.6,169.7c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C150,168.3,150.6,168.9,150.6,169.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M159.6,169.7c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C159,168.3,159.6,168.9,159.6,169.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M168.6,169.7c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C167.9,168.3,168.6,168.9,168.6,169.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.6,169.7c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C176.9,168.3,177.6,168.9,177.6,169.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.7,176.5c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4S141.7,175.7,141.7,176.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M150.6,176.5c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C150,175,150.6,175.7,150.6,176.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M159.6,176.5c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C159,175,159.6,175.7,159.6,176.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M168.6,176.5c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C167.9,175,168.6,175.7,168.6,176.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.6,176.5c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C176.9,175,177.6,175.7,177.6,176.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.7,183.2c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4S141.7,182.4,141.7,183.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M150.6,183.2c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C150,181.8,150.6,182.4,150.6,183.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M159.6,183.2c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C159,181.8,159.6,182.4,159.6,183.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M168.6,183.2c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C167.9,181.8,168.6,182.4,168.6,183.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.6,183.2c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C176.9,181.8,177.6,182.4,177.6,183.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.7,189.9c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4S141.7,189.2,141.7,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M150.6,189.9c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C150,188.5,150.6,189.2,150.6,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M159.6,189.9c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C159,188.5,159.6,189.2,159.6,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M168.6,189.9c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C167.9,188.5,168.6,189.2,168.6,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.6,189.9c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C176.9,188.5,177.6,189.2,177.6,189.9z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.2,54.2c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C301.6,52.7,302.2,53.4,302.2,54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.2,54.2c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C310.6,52.7,311.2,53.4,311.2,54.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 318.8,
    cy: 54.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 327.7,
    cy: 54.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 336.7,
    cy: 54.2,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.2,60.9c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C301.6,59.5,302.2,60.1,302.2,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.2,60.9c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C310.6,59.5,311.2,60.1,311.2,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320.2,60.9c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C319.5,59.5,320.2,60.1,320.2,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329.2,60.9c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C328.5,59.5,329.2,60.1,329.2,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M338.1,60.9c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C337.5,59.5,338.1,60.1,338.1,60.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.2,67.6c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C301.6,66.2,302.2,66.9,302.2,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.2,67.6c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C310.6,66.2,311.2,66.9,311.2,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320.2,67.6c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C319.5,66.2,320.2,66.9,320.2,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329.2,67.6c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C328.5,66.2,329.2,66.9,329.2,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M338.1,67.6c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C337.5,66.2,338.1,66.9,338.1,67.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.2,74.4c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C301.6,73,302.2,73.6,302.2,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.2,74.4c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C310.6,73,311.2,73.6,311.2,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320.2,74.4c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C319.5,73,320.2,73.6,320.2,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329.2,74.4c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C328.5,73,329.2,73.6,329.2,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M338.1,74.4c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C337.5,73,338.1,73.6,338.1,74.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.2,81.1c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C301.6,79.7,302.2,80.3,302.2,81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.2,81.1c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C310.6,79.7,311.2,80.3,311.2,81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320.2,81.1c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C319.5,79.7,320.2,80.3,320.2,81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329.2,81.1c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C328.5,79.7,329.2,80.3,329.2,81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M338.1,81.1c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C337.5,79.7,338.1,80.3,338.1,81.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.2,87.9c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C301.6,86.4,302.2,87.1,302.2,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.2,87.9c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C310.6,86.4,311.2,87.1,311.2,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320.2,87.9c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C319.5,86.4,320.2,87.1,320.2,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329.2,87.9c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C328.5,86.4,329.2,87.1,329.2,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M338.1,87.9c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C337.5,86.4,338.1,87.1,338.1,87.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054248596939696617920000006852780867680104119_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.46,
    y1: 230.1145,
    x2: 216.9014,
    y2: 124.2569,
    gradientTransform: "matrix(0.9999 -1.500000e-02 1.500000e-02 0.9999 -5.1153 -46.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9FFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054248596939696617920000006852780867680104119_)"
    },
    d: "M219.7,68.6l-4.1-4l-16.1,0.2 c-0.6,0-1,0.5-1,1.1l0.5,33.9c0,0.6,0.5,1,1.1,1l23.2-0.3c0.6,0,1-0.5,1-1.1l-0.4-26.8L219.7,68.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095318825034879891850000004890690836636969896_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.7377,
    y1: 101.7781,
    x2: 206.1417,
    y2: 136.9026,
    gradientTransform: "matrix(0.9999 -1.500000e-02 1.500000e-02 0.9999 -5.1153 -46.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9FFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095318825034879891850000004890690836636969896_)"
    },
    d: "M216.9,72.7l6.8-0.1l-4.1-4l-4.1-4 l0.1,6.8C215.7,72.1,216.2,72.7,216.9,72.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016035685530082429770000010069193958223231928_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.9063,
    y1: 144.7421,
    x2: 213.3723,
    y2: 121.8157,
    gradientTransform: "matrix(0.9999 -1.500000e-02 1.500000e-02 0.9999 -5.1153 -46.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000016035685530082429770000010069193958223231928_)"
    },
    points: "219.1,76.9 203.3,77.1  203.3,76.7 219.1,76.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177482139529190473330000000498681894528254650_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.9064,
    y1: 147.6999,
    x2: 213.3724,
    y2: 124.7735,
    gradientTransform: "matrix(0.9999 -1.500000e-02 1.500000e-02 0.9999 -5.1153 -46.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000177482139529190473330000000498681894528254650_)"
    },
    points: "219.1,79.9 203.4,80.1  203.4,79.6 219.1,79.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036961040437905763840000005163836110295494835_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.9065,
    y1: 150.6581,
    x2: 213.3724,
    y2: 127.7311,
    gradientTransform: "matrix(0.9999 -1.500000e-02 1.500000e-02 0.9999 -5.1153 -46.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000036961040437905763840000005163836110295494835_)"
    },
    points: "219.2,82.8 203.4,83.1  203.4,82.6 219.1,82.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099623193606738503530000012792803570590249115_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.9065,
    y1: 153.6154,
    x2: 213.3725,
    y2: 130.689,
    gradientTransform: "matrix(0.9999 -1.500000e-02 1.500000e-02 0.9999 -5.1153 -46.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000099623193606738503530000012792803570590249115_)"
    },
    points: "219.2,85.8 203.5,86  203.5,85.5 219.2,85.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145743658711143140720000011017584358794989726_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.9067,
    y1: 156.5736,
    x2: 213.3726,
    y2: 133.6466,
    gradientTransform: "matrix(0.9999 -1.500000e-02 1.500000e-02 0.9999 -5.1153 -46.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000145743658711143140720000011017584358794989726_)"
    },
    points: "219.2,88.7 203.5,89  203.5,88.5 219.2,88.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114057832163271257750000004760909782227830176_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.0587,
    y1: 151.4067,
    x2: 209.9512,
    y2: 138.5328,
    gradientTransform: "matrix(0.9999 -1.500000e-02 1.500000e-02 0.9999 -5.1153 -46.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000114057832163271257750000004760909782227830176_)"
    },
    points: "211.5,91.8 203.5,91.9  203.5,91.5 211.5,91.3  "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M250.1,127.6l-93.8,1.4c-1.7,0-3.1-1.4-3.2-3.1l-0.2-11.8c0-1.7,1.4-3.1,3.1-3.2l93.8-1.4 c1.7,0,3.1,1.4,3.2,3.1l0.2,11.8C253.2,126.2,251.9,127.6,250.1,127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M162.7,120.8c0.8-1,0.7-2.5-0.2-3.4c-1-1-2.6-0.9-3.6,0.1c-1,1-0.9,2.6,0.1,3.6c0.9,0.9,2.4,0.9,3.4,0.1 l2,1.9l0.3-0.3L162.7,120.8z M162.2,120.7c-0.8,0.8-2.1,0.8-2.9,0c-0.8-0.8-0.8-2.1,0-2.9c0.8-0.8,2.1-0.8,2.9,0 C163,118.6,163,119.9,162.2,120.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M173.6,118l0-0.4l-2,0l0.1,3.8l0.5,0l0-1.7l1.4,0l0-0.4l-1.4,0l0-1.3L173.6,118z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M175,118.7l0,2.7l0.5,0l0-2.7L175,118.7z M175.2,117.6c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3 c0.2,0,0.3-0.1,0.3-0.3C175.5,117.7,175.4,117.6,175.2,117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M177.1,117.4l0.1,4l0.5,0l-0.1-4L177.1,117.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M181.5,119.8c0-0.5-0.3-1.3-1.1-1.3c-0.8,0-1.3,0.7-1.3,1.5c0,0.8,0.5,1.4,1.4,1.4c0.4,0,0.7-0.1,0.9-0.2 l-0.1-0.4c-0.2,0.1-0.4,0.1-0.8,0.2c-0.5,0-0.9-0.3-1-0.9l1.9,0C181.5,120,181.5,119.9,181.5,119.8z M179.5,119.7 c0-0.3,0.2-0.8,0.8-0.8c0.6,0,0.7,0.5,0.7,0.8L179.5,119.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M186,119.1c-0.5-0.2-0.8-0.4-0.8-0.7c0-0.3,0.2-0.6,0.7-0.6c0.3,0,0.6,0.1,0.7,0.2l0.1-0.4 c-0.2-0.1-0.5-0.2-0.8-0.2c-0.7,0-1.2,0.5-1.2,1.1c0,0.5,0.4,0.9,1,1.1c0.5,0.2,0.7,0.4,0.7,0.7c0,0.4-0.3,0.7-0.8,0.7 c-0.3,0-0.7-0.1-0.9-0.2l-0.1,0.4c0.2,0.1,0.6,0.2,1,0.2c0.9,0,1.3-0.5,1.3-1.1C187,119.6,186.7,119.3,186,119.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M190.7,119.7c0-0.5-0.3-1.3-1.2-1.3c-0.8,0-1.3,0.7-1.3,1.5c0,0.8,0.5,1.4,1.4,1.4c0.4,0,0.7-0.1,0.9-0.2 l-0.1-0.4c-0.2,0.1-0.4,0.1-0.8,0.2c-0.5,0-0.9-0.3-1-0.9l1.9,0C190.7,119.9,190.7,119.8,190.7,119.7z M188.8,119.6 c0-0.3,0.2-0.8,0.8-0.8c0.6,0,0.7,0.5,0.7,0.8L188.8,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M194,120.5l0-1c0-0.5-0.2-1.1-1.1-1.1c-0.3,0-0.7,0.1-0.9,0.3l0.1,0.3c0.2-0.1,0.5-0.2,0.7-0.2 c0.6,0,0.6,0.4,0.6,0.6l0,0.1c-1.1,0-1.6,0.4-1.6,1c0,0.4,0.3,0.8,0.9,0.8c0.4,0,0.7-0.2,0.8-0.4l0,0l0,0.3l0.5,0 C194,120.9,194,120.7,194,120.5z M193.5,120.2c0,0.1,0,0.1,0,0.2c-0.1,0.2-0.3,0.5-0.7,0.5c-0.3,0-0.5-0.1-0.5-0.5 c0-0.5,0.6-0.6,1.1-0.6L193.5,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M196.8,118.3c-0.3,0-0.6,0.2-0.7,0.6l0,0l0-0.5l-0.4,0c0,0.3,0,0.5,0,0.9l0,1.9l0.5,0l0-1.5 c0-0.1,0-0.2,0-0.2c0.1-0.4,0.3-0.6,0.7-0.7c0.1,0,0.1,0,0.2,0l0-0.5C196.9,118.3,196.9,118.3,196.8,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M199.5,120.7c-0.5,0-1-0.4-1-1c0-0.6,0.3-1,1-1c0.3,0,0.5,0.1,0.6,0.1l0.1-0.4c-0.1-0.1-0.4-0.1-0.7-0.1 c-0.9,0-1.5,0.6-1.4,1.5c0,0.8,0.6,1.4,1.4,1.4c0.4,0,0.7-0.1,0.8-0.2l-0.1-0.4C199.9,120.6,199.7,120.7,199.5,120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M202.9,118.2c-0.2,0-0.4,0.1-0.5,0.1c-0.2,0.1-0.3,0.2-0.4,0.4l0,0l0-1.7l-0.5,0l0.1,4l0.5,0l0-1.7 c0-0.1,0-0.2,0-0.2c0.1-0.3,0.3-0.5,0.7-0.5c0.5,0,0.6,0.4,0.6,0.8l0,1.6l0.5,0l0-1.6C203.8,118.4,203.2,118.2,202.9,118.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.4,118.2l0,2.7l0.5,0l0-2.7L205.4,118.2z M205.7,117.1c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3 c0.2,0,0.3-0.1,0.3-0.3C206,117.3,205.8,117.1,205.7,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.9,118.1c-0.5,0-0.8,0.3-0.9,0.5l0,0l0-0.5l-0.4,0c0,0.2,0,0.5,0,0.7l0,2l0.5,0l0-1.6 c0-0.1,0-0.2,0-0.2c0.1-0.3,0.3-0.5,0.7-0.5c0.5,0,0.6,0.4,0.6,0.8l0,1.6l0.5,0l0-1.6C209.9,118.3,209.3,118.1,208.9,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.4,118.1l0,0.4l0,0c-0.1-0.2-0.4-0.5-0.9-0.5c-0.6,0-1.2,0.5-1.2,1.5c0,0.8,0.5,1.3,1.2,1.3 c0.4,0,0.7-0.2,0.9-0.5l0,0l0,0.3c0,0.7-0.4,1-0.9,1c-0.3,0-0.6-0.1-0.8-0.2l-0.1,0.4c0.2,0.1,0.6,0.2,0.9,0.2 c0.3,0,0.7-0.1,1-0.3c0.3-0.2,0.4-0.6,0.4-1.3l0-1.6c0-0.3,0-0.6,0-0.8L213.4,118.1z M213.3,119.7c0,0.1,0,0.2,0,0.3 c-0.1,0.3-0.4,0.5-0.7,0.5c-0.5,0-0.8-0.4-0.8-1c0-0.6,0.3-1,0.8-1c0.4,0,0.6,0.2,0.7,0.5c0,0.1,0,0.1,0,0.2L213.3,119.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003073922953449487700000002245892425333969570_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.0736,
    y1: 210.1615,
    x2: 176.6887,
    y2: 124.5128,
    gradientTransform: "matrix(0.9999 -1.500000e-02 1.500000e-02 0.9999 -5.1153 -46.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9FFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003073922953449487700000002245892425333969570_)"
    },
    d: "M179.5,71l-4.1-4l-16.1,0.2 c-0.6,0-1,0.5-1,1.1l0.5,33.9c0,0.6,0.5,1,1.1,1l23.2-0.3c0.6,0,1-0.5,1-1.1L183.6,75L179.5,71z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155140250092505985320000002907534615815257514_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.9363,
    y1: 71.9785,
    x2: 169.6981,
    y2: 152.8146,
    gradientTransform: "matrix(0.9999 -1.500000e-02 1.500000e-02 0.9999 -5.1153 -46.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9FFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155140250092505985320000002907534615815257514_)"
    },
    d: "M176.8,75.1l6.8-0.1l-4.1-4l-4.1-4 l0.1,6.8C175.5,74.5,176.1,75.1,176.8,75.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019669261594890034820000015884128035401885861_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.4122,
    y1: 204.4954,
    x2: 184.6426,
    y2: 104.5984,
    gradientTransform: "matrix(0.9999 -1.500000e-02 1.500000e-02 0.9999 -5.1153 -46.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-7,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019669261594890034820000015884128035401885861_)"
    },
    d: "M184.7,73.8l-4.1-4L164.5,70 c-0.6,0-1,0.5-1,1.1l0.5,33.9c0,0.6,0.5,1,1.1,1l23.2-0.3c0.6,0,1-0.5,1-1.1l-0.4-26.8L184.7,73.8z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M182,77.9l6.8-0.1l-4.1-4l-4.1-4l0.1,6.8C180.7,77.3,181.3,77.9,182,77.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050626174036501653740000017301973354317348755_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.1289,
    y1: 52.9593,
    x2: 206.4516,
    y2: 105.3746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6C80C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#393A3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050626174036501653740000017301973354317348755_)"
    },
    d: "M224.4,73.2l-4.1-4l-16.1,0.2 c-0.6,0-1,0.5-1,1.1l0.5,33.9c0,0.6,0.5,1,1.1,1l23.2-0.3c0.6,0,1-0.5,1-1.1l-0.4-26.8L224.4,73.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119809004019809837490000013031472220398697617_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.2365,
    y1: 53.7187,
    x2: 186.5561,
    y2: 126.4631
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000119809004019809837490000013031472220398697617_)"
    },
    d: "M221.7,77.3l6.8-0.1 l-4.1-4l-4.1-4l0.1,6.8C220.4,76.7,221,77.3,221.7,77.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 208.1,
    y: 81.2,
    transform: "matrix(0.9999 -1.502859e-02 1.502859e-02 0.9999 -1.1988 3.2544)",
    className: "st6",
    width: 15.7,
    height: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 208.1,
    y: 84.1,
    transform: "matrix(0.9999 -1.502868e-02 1.502868e-02 0.9999 -1.2433 3.2554)",
    className: "st6",
    width: 15.7,
    height: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 208.2,
    y: 87.1,
    transform: "matrix(0.9999 -1.502859e-02 1.502859e-02 0.9999 -1.2877 3.2564)",
    className: "st6",
    width: 15.7,
    height: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 208.2,
    y: 90,
    transform: "matrix(0.9999 -1.502858e-02 1.502858e-02 0.9999 -1.3322 3.2574)",
    className: "st6",
    width: 15.7,
    height: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 208.2,
    y: 93,
    transform: "matrix(0.9999 -1.502859e-02 1.502859e-02 0.9999 -1.3766 3.2584)",
    className: "st6",
    width: 15.7,
    height: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 208.3,
    y: 96,
    transform: "matrix(0.9999 -1.503260e-02 1.503260e-02 0.9999 -1.4227 3.2019)",
    className: "st6",
    width: 8,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166647053012969606890000016500060655553047204_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.8322,
    y1: 182.0779,
    x2: 174.9539,
    y2: 139.4599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000166647053012969606890000016500060655553047204_)"
    },
    points: "188.4,136.3 164.4,136.7  164.9,167 188.9,166.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174573155946253558580000002921224226450250155_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.0237,
    y1: 274.0148,
    x2: 173.4989,
    y2: 179.2251,
    gradientTransform: "matrix(0.9999 -1.500000e-02 1.500000e-02 0.9999 -5.1153 -46.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6C80C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#393A3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174573155946253558580000002921224226450250155_)"
    },
    d: "M193.5,144.7l0.4,24.6 c0,0.8-0.6,1.5-1.4,1.5l-31,0.5c-0.8,0-1.5-0.6-1.5-1.4l-0.3-18.6c0-0.8,0.6-1.5,1.4-1.5l14.6-0.2c0.6,0,1.1-0.3,1.3-0.9l2-4.4 c0.2-0.5,0.7-0.8,1.3-0.9l11.7-0.2C192.8,143.2,193.5,143.9,193.5,144.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081619946458337226190000017682759041403684739_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.4015,
    y1: 180.9223,
    x2: 221.7884,
    y2: 141.2434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000081619946458337226190000017682759041403684739_)"
    },
    points: "235.2,135.6 211.2,136  211.6,166.3 235.6,165.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102530277974661111220000003480249075700286390_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.9855,
    y1: 268.4625,
    x2: 220.739,
    y2: 185.4612,
    gradientTransform: "matrix(0.9999 -1.500000e-02 1.500000e-02 0.9999 -5.1153 -46.1955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-7,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102530277974661111220000003480249075700286390_)"
    },
    d: "M240.2,144l0.4,24.6 c0,0.8-0.6,1.5-1.4,1.5l-31,0.5c-0.8,0-1.5-0.6-1.5-1.4l-0.3-18.6c0-0.8,0.6-1.5,1.4-1.5l14.6-0.2c0.6,0,1.1-0.3,1.3-0.9l2-4.4 c0.2-0.5,0.7-0.8,1.3-0.9l11.7-0.2C239.6,142.5,240.2,143.2,240.2,144z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067210177401664480190000017341054979561683603_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.8282,
    y1: 162.326,
    x2: 130.5406,
    y2: 231.4084
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-7,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067210177401664480190000017341054979561683603_)"
    },
    d: "M144.2,240.8c0,0-5.7-26.2-9.8-32.5 c-4.1-6.2-2.7-1.6-6.4-2.5c-3.7-0.9,2.2-1.9-1.7-6.8c-3.9-4.9-5.2-3-6.8-0.5s-2.2-2.6-1.1-5.8c1-3.2-7.4-11-10.9-11.6 c-3.4-0.6-1.6,2.2-3.5,3.7c-1.8,1.4,0-1.8-2.4-5.8c-2.3-4-16-4.5-17.7-8.5c1.5,13.4,16,26.6,18.9,26.3s5.7-1.9,6.2-0.2 c0.5,1.7-4.8,0.1-3.8,2.7c1,2.5,9.8,13.6,12.3,14.2c2.6,0.6,5.6-2.3,6.7-0.7c1.1,1.6-4.2,2-1.8,6c2.4,4,12.5,23.9,16.5,24.1 C143.2,243.1,144.2,240.8,144.2,240.8z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M84.1,170.6c0,0,2.4,6.4,11.6,13.7c9.2,7.3,19.6,14.4,26.3,21.4c6.7,7,21.1,33.4,21.1,33.4"
  })), /*#__PURE__*/React.createElement("g", null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.5,267.1l14.2-6.2c1.1-0.5,1.7-1.7,1.3-2.9l-8.1-23.6c-0.4-1.3-1.9-1.9-3.1-1.4l-18,7.9 c-1.2,0.5-1.8,2-1.1,3.2l11.9,21.9C142.1,267.2,143.4,267.6,144.5,267.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128480577834733464590000008824130999841252532_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.0773,
    y1: 286.7693,
    x2: 163.6125,
    y2: 227.2987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6C80C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#393A3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128480577834733464590000008824130999841252532_)"
    },
    d: "M130,247l23.8-10.4 c0.6-0.3,0.9-1.1,0.5-1.6l-3.1-4.7c-0.3-0.5-0.9-0.6-1.4-0.4l-22.1,9.7c-0.5,0.2-0.8,0.8-0.6,1.3l1.4,5.5 C128.6,246.9,129.4,247.2,130,247z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051376864443194239940000013523963988537825162_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.8652,
    y1: 74.9634,
    x2: 409.62,
    y2: 174.2058
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-7,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051376864443194239940000013523963988537825162_)"
    },
    d: "M406.8,183.1c0,0,0.9-26.8,3.8-33.7 c2.9-6.9,2.4-2,5.8-3.6c3.4-1.6-2.5-1.5,0.5-7s4.6-3.9,6.6-1.7c2,2.2,1.7-2.9,0.1-5.9c-1.6-3,5.3-12.2,8.6-13.3 c3.3-1.2,2,1.9,4,3c2.1,1.1-0.3-1.8,1.3-6.1c1.6-4.3,15-7.3,15.9-11.5c0.9,13.5-11,29-13.9,29.2c-2.9,0.2-5.9-0.8-6.1,0.9 c-0.2,1.8,4.7-0.7,4.2,1.9c-0.6,2.7-7.2,15.1-9.6,16.2c-2.4,1-6-1.3-6.7,0.5c-0.8,1.7,4.5,1.2,2.8,5.6c-1.7,4.4-8,25.8-12,26.7 C408.2,185.1,406.8,183.1,406.8,183.1z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M453.5,103.2c0,0-1.2,6.7-9,15.5c-7.8,8.8-16.7,17.6-22.1,25.7c-5.4,8.1-12.7,26.7-12.7,26.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080906713921419933210000003656539227302221746_",
    gradientUnits: "userSpaceOnUse",
    x1: 592.5478,
    y1: 95.4805,
    x2: 400.6959,
    y2: 177.9847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6C80C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#393A3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080906713921419933210000003656539227302221746_)"
    },
    d: "M404.7,192.3c-1.6-7.3,3-7.7,8-13.4 c5-5.7,2.2-11.5,8.2-14.6c6.1-3.1,3.7-8.8,9.1-12.7c5.4-3.9,4.9-7.4,4.9-7.4s2.7,4.3-0.7,11c-3.4,6.7-6.1,6.1-7.4,11.9 s-5.3,2.7-7.2,9s-3.2,7.6-5.4,10.1c-2.2,2.6-1.2,6.5-4.5,6.9C406.4,193.4,404.7,192.3,404.7,192.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062186314035440876600000016156162020996363695_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.9945,
    y1: 145.389,
    x2: 417.2645,
    y2: 203.3703,
    gradientTransform: "matrix(0.9786 0.2058 -0.2058 0.9786 34.7407 -106.8638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#135C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 5.381067e-7,
    style: {
      stopColor: "#006666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66CC99"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062186314035440876600000016156162020996363695_)"
    },
    d: "M408.5,194c0,0,7.8-44.5-1.5-53.4 c-9.3-9-14.9,0.8-16,11.1c-1.1,10.4,13.4,31.1,8.8,44.8"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M399.5,137.1c0,0,7.2,33.3,6,58.5"
  })), /*#__PURE__*/React.createElement("g", null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.5,218.9l-15.1-3.6c-1.2-0.3-1.9-1.4-1.8-2.6l3.8-24.7c0.2-1.3,1.5-2.2,2.8-1.9l19.1,4.6 c1.3,0.3,2.1,1.7,1.7,3l-7.8,23.7C408.9,218.5,407.7,219.2,406.5,218.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045593782450870594970000012536505310799675787_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.3603,
    y1: 321.413,
    x2: 411.3621,
    y2: 167.1952
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4255B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6C80C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#393A3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045593782450870594970000012536505310799675787_)"
    },
    d: "M417.2,196.5l-25.3-6.1 c-0.7-0.2-1-0.9-0.8-1.5l2.2-5.2c0.2-0.5,0.8-0.8,1.3-0.7l23.5,5.6c0.5,0.1,0.9,0.6,0.9,1.2l-0.4,5.6 C418.5,196.1,417.9,196.6,417.2,196.5z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.8b7158a0defbc08f2669f9f0886cd022.svg";
export { ForwardRef as ReactComponent };